import React, {Component} from 'react'
import {Button, Drawer, Form} from 'antd';
import Swal from "sweetalert2";
import eyeIcon from "../../../assets/icons/eye.svg";
import eyeIconSlash from "../../../assets/icons/eye-slash-grey.svg";
import "../../styling.css"
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {withTourGuide} from "../../guideComponent/withTourGuide";

class UserAdd extends Component {
    constructor() {
        super();
        this.state = {
            p_user_name     : '',
            p_user_email    : '',
            p_user_wa    : '',
            p_user_password : '',
            p_user_level : '',
            loading         : false,
            hidePassword    : false
        }
        this.triggerGuideOnce = this.triggerGuideOnce.bind(this)
    }

    triggerGuideOnce = (e, config) => {
        const { showGuide, isGuideActive, disabledKeys } = this.props;

        const target = e?.currentTarget ?? null;
        if (!target || !config?.key) return;
        if (disabledKeys?.includes(config.key)) return;
        if (isGuideActive) return;
        if (typeof showGuide !== 'function') return;
        showGuide(target, config);
    };

    handleSubmit = () => {
        this.setState({
            loading: true
        })
        let form = {
            p_user_name     : this.state.p_user_name,
            p_user_email    : this.state.p_user_email,
            p_user_wa    : this.state.p_user_wa,
            p_user_password : this.state.p_user_password,
            p_user_level : this.state.p_user_level,
        }

        this.props.request("add_user", form, 'POST')
            .then(response => {
                if (response && response.success) {
                    this.setState({p_user_name: ''})
                    this.props.changeState({
                        p_user_name: '',
                        add_visible: false,
                        data: [],
                        isLoading: true,
                    }, () => this.props.loadData())
                    Swal.fire({
                        title: 'Berhasil!',
                        text: response.message,
                        icon: 'success'
                    })
                }else if (response) {
                    Swal.fire({
                        title: 'Gagal!',
                        text: response.message,
                        icon: 'warning',
                        confirmButtonText: 'OK'
                    })
                }
                this.setState({
                    loading: false
                })
            });
    }

    render() {
        return (
            <Modal size="lg" zIndex={999} isOpen={this.props.add_visible} toggle={() => {
                this.props.changeState({add_visible: false});
            }}>
                <ModalHeader toggle={() => {
                    this.props.changeState({add_visible: false});
                }}>Tambah User</ModalHeader>
                <ModalBody>
                    <div className="px-2">
                        <Form layout="vertical" hideRequiredMark>
                            <div
                                className="form-group"
                                onPointerEnter={(e) => {
                                    this.triggerGuideOnce(e, {
                                        key: "guideNamaUser",
                                        title: "Nama User",
                                        content: "Masukkan nama lengkap user yang akan dibuatkan akun."
                                    });
                                }}
                            >
                                <label>Nama User</label>
                                <input
                                    name="p_user_name"
                                    className="form-control col-xl-12 col-md-12"
                                    placeholder="Nama User..."
                                    type="text"
                                    required=""
                                    value={this.state.p_user_name}
                                    onChange={(event) => {
                                        const target = event.target;
                                        const value = target.value;
                                        const name = target.name;
                                        this.setState({
                                            [name]: value
                                        });
                                    }}
                                />
                            </div>

                            <div
                                className="form-group"
                                onPointerEnter={(e) => {
                                    this.triggerGuideOnce(e, {
                                        key: "guideEmailUser",
                                        title: "Email User",
                                        content: "Masukkan email aktif user. Email ini biasanya digunakan untuk login atau notifikasi sistem."
                                    });
                                }}
                            >
                                <label>Email User</label>
                                <input
                                    name="p_user_email"
                                    className="form-control col-xl-12 col-md-12"
                                    placeholder="Email User..."
                                    type="text"
                                    required=""
                                    value={this.state.p_user_email}
                                    onChange={(event) => {
                                        const target = event.target;
                                        const value = target.value;
                                        const name = target.name;
                                        this.setState({
                                            [name]: value
                                        });
                                    }}
                                />
                            </div>

                            <div
                                className="form-group"
                                onPointerEnter={(e) => {
                                    this.triggerGuideOnce(e, {
                                        key: "guideWaUser",
                                        title: "No. WA User",
                                        content: "Masukkan nomor WhatsApp user jika ada. Field ini bersifat opsional dan bisa dikosongkan."
                                    });
                                }}
                            >
                                <label>No. WA User (Opsional)</label>
                                <input
                                    name="p_user_wa"
                                    className="form-control col-xl-12 col-md-12"
                                    placeholder="No Wa User..."
                                    type="number"
                                    required=""
                                    value={this.state.p_user_wa}
                                    onChange={(event) => {
                                        const target = event.target;
                                        const value = target.value;
                                        const name = target.name;
                                        this.setState({
                                            [name]: value
                                        });
                                    }}
                                />
                            </div>

                            <div
                                className="form-group"
                                onPointerEnter={(e) => {
                                    this.triggerGuideOnce(e, {
                                        key: "guidePasswordUser",
                                        title: "Password User",
                                        content: "Masukkan password awal untuk akun user. Gunakan kombinasi yang aman dan mudah dikelola oleh admin."
                                    });
                                }}
                            >
                                <label>Password User</label>
                                <div className="input-group btn-password-add-akun">
                                    <input
                                        name="p_user_password"
                                        className="form-control col-xl-12 col-md-12"
                                        placeholder="Password User..."
                                        type={this.state.hidePassword ? "text" : "password"}
                                        required=""
                                        value={this.state.p_user_password}
                                        onChange={(event) => {
                                            const target = event.target;
                                            const value = target.value;
                                            const name = target.name;
                                            this.setState({
                                                [name]: value
                                            });
                                        }}
                                    />
                                    <div className="input-group-append">
                                        <div className="input-group-text">
                                            <img
                                                className="show-hide-button"
                                                style={{ width: "16px", height: "16px", backgroundColor: "#E9ECEF", cursor: "pointer" }}
                                                src={this.state.hidePassword ? eyeIcon : eyeIconSlash}
                                                onClick={() =>
                                                    this.setState({
                                                        hidePassword: !this.state.hidePassword
                                                    })
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div
                                className="form-group"
                                onPointerEnter={(e) => {
                                    this.triggerGuideOnce(e, {
                                        key: "guideLevelUser",
                                        title: "Level User",
                                        content: "Pilih level atau hak akses user sesuai peran yang akan digunakan di sistem."
                                    });
                                }}
                            >
                                <label>Level User</label>
                                <select
                                    name="p_user_level"
                                    className="form-control col-xl-12 col-md-12"
                                    value={this.state.p_user_level}
                                    onChange={(event) => {
                                        const target = event.target;
                                        const value = target.value;
                                        const name = target.name;
                                        this.setState({
                                            [name]: value
                                        });
                                    }}
                                >
                                    <option value="">Pilih Level User</option>
                                    {this.props.data.dataLevel &&
                                        this.props.data.dataLevel.map((item, index) => {
                                            return (
                                                <option key={item.level_id || index} value={item.level_id}>
                                                    {item.level_name}
                                                </option>
                                            );
                                        })}
                                </select>
                            </div>
                        </Form>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <div
                        style={{
                            textAlign: 'right',
                        }}
                    >
                        <Button onClick={() => {
                            this.props.changeState({add_visible: false, p_user_name: ''});
                        }}
                                style={{marginRight: 8}}>
                            Batal
                        </Button>
                        <Button onClick={this.handleSubmit} disabled={this.state.loading} type="primary">
                            {this.state.loading ?
                                <><i className={"fa fa-refresh fa-spin"}></i> Loading</>
                                :
                                "Simpan"
                            }
                        </Button>
                    </div>
                </ModalFooter>
            </Modal>
        )
    }
}

export default withTourGuide(UserAdd)
